import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/stores/useAuthStore';

const RETURN_URL_KEY = 'apx_insight_return_url';

export function ProtectedRoute() {
  const { isAuthenticated } = useAuthStore();
  const location = useLocation();

  if (!isAuthenticated) {
    // Save the current URL so we can redirect back after login
    const currentPath = location.pathname + location.search;
    if (currentPath !== '/' && currentPath !== '/login') {
      sessionStorage.setItem(RETURN_URL_KEY, currentPath);
    }
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
